export default __webpack_public_path__ + "static/media/materialui.058fe09b.png";